import axios from "axios"
import { getApiUrl } from "utils/api/apiUrl"
import useOpus from "contexts/opus/hooks/use-opus"
import { AddressServiceType } from "./types"

const API_URL = `${getApiUrl(window.location.host)}/v2/lookup/address`

export const useAddressService: AddressServiceType = () => {
  const { opusToken, getToken } = useOpus()

  const client = axios.create({
    baseURL: API_URL,
    headers: {
      "Content-Type": "application/json"
    }
  })

  const search = async (query: string, countryCodes?: string[]) => {
    // Address search is reCAPTCHA-protected on the Platform API and the portal has no
    // reCAPTCHA of its own. The API skips verification for authenticated Opus callers,
    // so send the same session token the portal already uses against the Opus API.
    const token = opusToken || (await getToken())

    const response = await client.post(
      "/search",
      {
        query,
        countryCodes
      },
      { headers: { authorization: `Bearer ${token}` } }
    )

    return response?.data?.data
  }

  const format = async (query: string) => {
    const response = await client.post(`/detail`, { query })

    return response?.data?.data
  }

  return {
    search,
    format
  }
}
